import BusinessSearch from '../../../components/BusinessSearch';

export default BusinessSearch; 